import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import messages from './local/index';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    // No hardcoded `lng`: let the detector restore the user's saved choice from
    // localStorage so toggling to English persists across reloads. First-time
    // visitors (no saved choice) fall back to Spanish, the default market.
    fallbackLng: 'es',
    supportedLngs: ['es', 'en'],
    debug: false,
    resources: messages,
    detection: {
      order: ['localStorage'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;